<template>
  <footer class="secondary">
    <v-container class="py-0">
      <div class="py-9">
        <div class="footer-section-top justify-center justify-space-sm-between">
          <div class="d-flex flex-column my-auto mx-auto">
            <img
              :src="files + informations.img"
              :alt="informations.name"
              class="footer-logo filter-white"
            />
            <div class="footer-social d-flex">
              <Tooltip
                v-for="({ title, link, icon }, i) in social"
                :key="i"
                :tip="title"
                bottom
              >
                <v-btn
                  :href="link"
                  target="_blank"
                  color="white"
                  height="46px"
                  width="46px"
                  outlined
                  icon
                >
                  <v-icon size="22">{{ icon }}</v-icon>
                </v-btn>
              </Tooltip>
            </div>
          </div>
          <div>
            <div
              class="
                footer-section-title
                mb-4
                font-weight-bold
                white--text
                text-body-1
              "
            >
              Informações de Contato
            </div>
            <div class="footer-contact d-flex flex-column">
              <div
                v-for="({ title, link, icon }, i) in contact"
                :key="i"
                class="d-flex align-center"
              >
                <v-btn
                  :href="link"
                  target="_blank"
                  color="white"
                  class="mr-2"
                  small
                  icon
                >
                  <v-icon size="18">{{ icon }}</v-icon>
                </v-btn>
                <a
                  class="text-body-2 white--text text-decoration-none"
                  :href="link"
                  target="_blank"
                  >{{ title }}</a
                >
              </div>
              <div class="d-flex align-center">
                <v-btn
                  color="white"
                  class="mr-2"
                  small
                  icon
                  @click="showPrivacy"
                >
                  <v-icon size="18"> fa fa-shield </v-icon>
                </v-btn>
                <a
                  class="text-body-2 white--text text-decoration-none"
                  @click="showPrivacy"
                >
                  Política de Privacidade
                </a>
              </div>
            </div>
          </div>
          <div>
            <div
              class="
                footer-section-title
                mb-4
                font-weight-bold
                white--text
                text-body-1
              "
            >
              Notícias
            </div>
            <div class="footer-categories-list">
              <div v-for="({ text, to }, i) in categories" :key="i">
                <v-btn :to="to" class="text-body-2 white--text text-none" text>
                  {{ text }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-sheet
        min-height="45px"
        color="transparent"
        class="
          white--text
          d-flex
          justify-space-between
          align-center
          flex-column flex-sm-row
          py-4 py-sm-0
        "
      >
        <div class="text-body-2 text-center">
          <span>
            Copyright © {{ year }} <b>{{ informations.name }}</b
            >.
          </span>
          <span> Todos os Direitos Reservados. </span>
        </div>
        <a href="https://mrxweb.com.br/" target="_blank">
          <img
            class="logo-mrx filter-white mt-4 mt-sm-0"
            src="/img/mrx.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
          />
        </a>
      </v-sheet>
    </v-container>
  </footer>
</template>

<script>
import { formatToURL } from "@/components/utils.js";
import Tooltip from "../tools/Tooltip.vue";
import { getSocial, getContact } from "@/config.js";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    categories() {
      return this.$rest(`articles-categories`).list.map(({ title }) => ({
        text: title,
        to: `/noticias/${formatToURL(title)}`,
      }));
    },
    informations() {
      return this.$rest(`informations`).item;
    },
    social() {
      return getSocial(this);
    },
    contact() {
      return getContact(this);
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.footer-section-top {
  display: grid;
  grid-template-columns: min-content max-content min-content;
  grid-gap: 60px;
}
.footer-logo {
  width: 199px;
  margin-bottom: 31px;
}
.footer-social {
  gap: 24px;
}
.logo-mrx {
  height: 20px;
}
.footer-contact {
  gap: 16px;
}

.footer-categories-list {
  column-count: 2;
}

.footer-section-title::after {
  content: "";
  display: block;
  padding-top: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-width: 0 0 1px 0;
}

@media screen and (min-width: 600.001px) and (max-width: 960px) {
  .footer-section-top {
    grid-template-columns: max-content max-content;
  }
  .footer-section-top > :nth-child(1) {
    grid-column: span 2;
  }
}

@media screen and (max-width: 600px) {
  .footer-section-top {
    grid-template-columns: auto;
  }
}
</style>
